module.exports = __webpack_public_path__ + "img/research-icon.cf130d66.svg";